import { QueryStatus } from './queryStatus';

export interface DataResultKeyed<T> {
  items: T[];
  total?: number | null;
  available: number | null;
  cursor: string | null;
  hasNext?: boolean | null;
}

export interface QueryResult<T> {
  items: T[];
  total: number;
  available: number | null;
  status: QueryStatus;
}
